import { render, staticRenderFns } from "./FmcsaChecklistItem.vue?vue&type=template&id=207d4338&scoped=true&"
import script from "./FmcsaChecklistItem.vue?vue&type=script&lang=js&"
export * from "./FmcsaChecklistItem.vue?vue&type=script&lang=js&"
import style0 from "./FmcsaChecklistItem.vue?vue&type=style&index=0&id=207d4338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d4338",
  null
  
)

export default component.exports